import React from 'react';
import '../../css/spinner.css';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/autocomplete-municipality-react-query'));

export default function (dependencies) {
  const { language } = dependencies;
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...dependencies, ...props });
  };

  return {
    html,
    validators: [
      function (state, config, _) {
        if (!state.county) return language['not_valid_municipality'];
        return;
      },
    ],
    config: {
      behaviour: 'text-input',
      validators: ['mandatory'],
    },
  };
}
